"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledWrapper = exports.StyledMaskButton = exports.StyledLeadingCharacter = exports.StyledLabel = exports.StyledInputIcon = exports.StyledInputContainer = exports.StyledInput = exports.StyledHelperText = exports.StyledDescriptionContainer = exports.StyledCharacterCounter = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _buttons = require("../../fuse-buttons/src/buttons");
var _iconElement = require("../../fuse-icon-element/src/icon-element");
var _typography = _interopRequireDefault(require("../../fuse-typography-element/src/typography"));
var _configs = require("./configs");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var borderColor = _configs.styledInputConfig.borderColor,
  borderRadius = _configs.styledInputConfig.borderRadius,
  borderWidth = _configs.styledInputConfig.borderWidth,
  componentName = _configs.styledInputConfig.componentName,
  helperTextColor = _configs.styledInputConfig.helperTextColor;
var StyledWrapper = exports.StyledWrapper = _styledComponents["default"].div.attrs({
  className: componentName
}).withConfig({
  displayName: "styled-input__StyledWrapper",
  componentId: "sc-zqyfbv-0"
})(["width:100%;&.fuse-input--disabled div{background-color:unset;}&.fuse-input--disabled label,&.fuse-input--disabled span,&.fuse-input--disabled p,&.fuse-input--disabled input{color:var(--color-global-grey400);}&.fuse-input--disabled button{color:var(--color-global-grey400);&:hover,&:focus,&:active{outline:none;cursor:initial;}}&.fuse-input--disabled div,&.fuse-input--disabled input{border-color:var(--color-global-grey400);background-color:unset;}&.fuse-input--disabled .", "__input-icon{background-color:var(--color-global-grey400);}"], componentName);
var StyledLabel = exports.StyledLabel = _styledComponents["default"].label.attrs({
  className: "".concat(componentName, "__label")
}).withConfig({
  displayName: "styled-input__StyledLabel",
  componentId: "sc-zqyfbv-1"
})(["color:var(--color-global-black);display:block;font-size:var(--font-size-1);font-weight:var(--font-weight-paragraph);margin-bottom:var(--spacing-global-space3);line-height:var(--font-line-height-1);"]);
var StyledInputContainer = exports.StyledInputContainer = _styledComponents["default"].div.attrs({
  className: "".concat(componentName, "__input-container")
}).withConfig({
  displayName: "styled-input__StyledInputContainer",
  componentId: "sc-zqyfbv-2"
})(["background:var(--color-global-white);", ""], function (_ref) {
  var state = _ref.state;
  return "\n    align-items: center;\n    border: ".concat(borderWidth, " solid ").concat((borderColor === null || borderColor === void 0 ? void 0 : borderColor[state]) || "var(--color-global-grey400)", ";\n    color: var(--color-global-grey900);\n    display: flex;\n    font-size: var(--font-size-1);\n    line-height: var(--font-line-height-1);\n\toverflow: hidden;\n    width: 100%;\n\n    ").concat(borderRadius, ";\n\n    &:hover {\n      border-color: ").concat((borderColor === null || borderColor === void 0 ? void 0 : borderColor[state]) || "var(--color-global-grey700)", ";\n    }\t\t\t\n\n    &:focus-within {\n      border-color: ").concat((borderColor === null || borderColor === void 0 ? void 0 : borderColor[state]) || "var(--color-brand-mid)", ";\n    }\n\n    &.").concat(componentName, "__input-container--outline {\n      ").concat(_fuseUtils.FocusCss, "\n    }\n\n  ");
});
var StyledInput = exports.StyledInput = _styledComponents["default"].input.attrs({
  className: "".concat(componentName, "__input")
}).withConfig({
  displayName: "styled-input__StyledInput",
  componentId: "sc-zqyfbv-3"
})(["border:none;color:var(--color-global-grey900);flex:1 1 auto;height:var(--spacing-global-space9);font-size:var(--font-size-1);outline:none;width:100%;padding:var(--spacing-global-space3) var(--spacing-global-space4) var(--spacing-global-space3) 0;&:first-child{padding:var(--spacing-global-space3) var(--spacing-global-space4);}&[type='password']{font-family:Arial;}&[type='number']{::-webkit-outer-spin-button,::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}-moz-appearance:textfield;}&::-ms-reveal{display:none;}"]);
var StyledLeadingCharacter = exports.StyledLeadingCharacter = _styledComponents["default"].span.attrs({
  className: "".concat(componentName, "__input-leading")
}).withConfig({
  displayName: "styled-input__StyledLeadingCharacter",
  componentId: "sc-zqyfbv-4"
})(["font-size:var(--font-size-1);font-weight:var(--font-weight-heading);padding:0 var(--spacing-global-space2) 0 var(--spacing-global-space4);abbr{text-decoration:none;}"]);
var StyledMaskButton = exports.StyledMaskButton = (0, _styledComponents["default"])(_buttons.PlainIconButton).attrs({
  className: "".concat(componentName, "__mask-button")
}).withConfig({
  displayName: "styled-input__StyledMaskButton",
  componentId: "sc-zqyfbv-5"
})(["align-items:center;display:flex;justify-content:center;width:var(--spacing-global-space9);height:var(--spacing-global-space9);&:focus{outline-offset:-4px;}"]);
var StyledInputIcon = exports.StyledInputIcon = (0, _styledComponents["default"])(_iconElement.Icon).attrs({
  className: "".concat(componentName, "__input-icon")
}).withConfig({
  displayName: "styled-input__StyledInputIcon",
  componentId: "sc-zqyfbv-6"
})(["flex-shrink:0;margin:0 var(--spacing-global-space3);"]);
var StyledDescriptionContainer = exports.StyledDescriptionContainer = _styledComponents["default"].div.attrs({
  className: "".concat(componentName, "__input-description")
}).withConfig({
  displayName: "styled-input__StyledDescriptionContainer",
  componentId: "sc-zqyfbv-7"
})(["", ""], function (_ref2) {
  var isHelperText = _ref2.isHelperText;
  return "\n\t\tdisplay: flex;\n\t\tjustify-content: ".concat(isHelperText ? 'flex-start' : 'flex-end', ";\n\t\tpadding-top: var(--spacing-global-space3);\n\t");
});
var StyledHelperText = exports.StyledHelperText = (0, _styledComponents["default"])(_typography["default"]).attrs({
  className: "".concat(componentName, "__helper-text")
}).withConfig({
  displayName: "styled-input__StyledHelperText",
  componentId: "sc-zqyfbv-8"
})(["color:", ";flex:1 1 auto;"], function (_ref3) {
  var state = _ref3.state;
  return (helperTextColor === null || helperTextColor === void 0 ? void 0 : helperTextColor[state]) || "var(--color-global-grey800)";
});
var StyledCharacterCounter = exports.StyledCharacterCounter = (0, _styledComponents["default"])(_typography["default"]).attrs({
  className: "".concat(componentName, "__character-counter")
}).withConfig({
  displayName: "styled-input__StyledCharacterCounter",
  componentId: "sc-zqyfbv-9"
})(["color:", ";margin-left:var(--spacing-global-space3);"], function (_ref4) {
  var state = _ref4.state;
  return (helperTextColor === null || helperTextColor === void 0 ? void 0 : helperTextColor[state]) || "var(--color-global-grey800)";
});